<loader [whiteBackground]="true"></loader>